module.exports = __webpack_public_path__ + "static/media/tell_us_what_you_love_2021.e9fdf30f.jpeg";